import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleGuard } from '../../guard/auth-guard/role.guard';
import { Role } from '../../core/enums/role.enum';
import { alteracoesNaoSalvasGuard } from '../../core/guards/alteracoes-nao-salvas.guard';

const TODAS_PERMISSOES_REG_ATIVIDADE = [
  Role.PARAM_REG_ATIVIDADE_VISUALIZAR,
  Role.PARAM_REG_ATIVIDADE_EDITAR,
  Role.PARAM_REG_ATIVIDADE_CONFIGURACAO_GLOBAL,
  Role.PARAM_REG_ATIVIDADE_RELATORIO_PDF,
];

export const atividadeProfissionalRoutes: Routes = [
  {
    path: 'pagamento/parametrizacao-atividade-profissional',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      title: 'Parametrização de Registros de Atividade do Profissional',
      roles: TODAS_PERMISSOES_REG_ATIVIDADE,
      breadcrumb: [
        { label: 'Pagamento', url: '/pagamento' },
        { label: 'Parametrização de Registros de Atividade do Profissional', url: '/pagamento/parametrizacao-atividade-profissional' },
      ],
    },
    loadComponent: () =>
      import('./atividade-profissional-listagem/atividade-profissional-listagem.component').then(
        (m) => m.AtividadeProfissionalListagemComponent,
      ),
  },
  {
    path: 'pagamento/parametrizacao-atividade-profissional/global/:registroId',
    canActivate: [AuthGuard, RoleGuard],
    canDeactivate: [alteracoesNaoSalvasGuard],
    data: {
      title: 'Configuração Global',
      modo: 'global',
      roles: [Role.PARAM_REG_ATIVIDADE_CONFIGURACAO_GLOBAL],
      breadcrumb: [
        { label: 'Pagamento', url: '/pagamento' },
        { label: 'Parametrização de Registro de Atividades profissional', url: '/pagamento/parametrizacao-atividade-profissional' },
        { label: 'Configuração Global' },
      ],
    },
    loadComponent: () =>
      import('./atividade-profissional-form/atividade-profissional-form.component').then(
        (m) => m.AtividadeProfissionalFormComponent,
      ),
  },
  {
    path: 'pagamento/parametrizacao-atividade-profissional/mensal/:coSeqMes',
    canActivate: [AuthGuard, RoleGuard],
    canDeactivate: [alteracoesNaoSalvasGuard],
    data: {
      title: 'Configuração Mensal',
      modo: 'mensal',
      roles: [Role.PARAM_REG_ATIVIDADE_EDITAR],
      breadcrumb: [
        { label: 'Pagamento', url: '/pagamento' },
        { label: 'Parametrização de Registro de Atividades profissional', url: '/pagamento/parametrizacao-atividade-profissional' },
        { label: 'Configuração Mensal' },
      ],
    },
    loadComponent: () =>
      import('./atividade-profissional-form/atividade-profissional-form.component').then(
        (m) => m.AtividadeProfissionalFormComponent,
      ),
  },
  {
    path: 'pagamento/parametrizacao-atividade-profissional/visualizar/:coSeqMes',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      title: 'Visualizar Configuração',
      roles: TODAS_PERMISSOES_REG_ATIVIDADE,
      breadcrumb: [
        { label: 'Pagamento', url: '/pagamento' },
        { label: 'Parametrização de Registro de Atividades profissional', url: '/pagamento/parametrizacao-atividade-profissional' },
        { label: 'Visualizar' },
      ],
    },
    loadComponent: () =>
      import('./atividade-profissional-visualizar/atividade-profissional-visualizar.component').then(
        (m) => m.AtividadeProfissionalVisualizarComponent,
      ),
  },
];
